import { render } from "./VirtualAccountInfo.vue?vue&type=template&id=2992e0b5"
import script from "./VirtualAccountInfo.vue?vue&type=script&lang=js"
export * from "./VirtualAccountInfo.vue?vue&type=script&lang=js"

import "./VirtualAccountInfo.vue?vue&type=style&index=0&id=2992e0b5&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__